import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OperationType } from 'common/constants/sm-constants';
import { ResetForgotPasswordModel } from 'common/models/page-models/Login/reset-password/reset-password-data-model';
import { RouteEnvelope } from 'common/models/utility-models/base-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { ResetForgotPasswordFormWidgetService } from 'common/widget/login/resetpassword-form-widget';



@Injectable({
    providedIn: 'root'
})
export class ResetForgotPasswordFormResolver extends FormResolverService<ResetForgotPasswordModel> {
    constructor(
        protected fs: ResetForgotPasswordFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);

    }

    // override modifyResponseData(dataModel, meta, widget) {
    //     dataModel['email'] = widget.transferData.email;
    //     return dataModel;
    // }
    override manageState() {
        console.log('inside reset password resolver')
        if (this.router.getCurrentNavigation().extras.state === undefined) {
          const envelope = new RouteEnvelope();
          envelope.type =  OperationType.CREATE;
          return envelope;
        } else {
          return this.router.getCurrentNavigation().extras.state;
        }
      }

}

